import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { useReadOnly } from '@/lib/auth-hooks';

/**
 * Subtle top-strip rendered on every app page when the active user
 * is operating in read-only mode. Frontend hiding is a UX
 * convenience — the backend's PolicyService still rejects write
 * attempts even when the UI shows them.
 */
export function ReadOnlyBanner(): JSX.Element | null {
  const { t } = useTranslation();
  const isReadOnly = useReadOnly();
  if (!isReadOnly) return null;
  return (
    <div className="flex items-center justify-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-xs text-amber-900">
      <Lock className="h-3.5 w-3.5" aria-hidden="true" />
      <span>{t('common.read_only_active')}</span>
    </div>
  );
}
